import { useUser } from "@/context/user-context";
import { useState } from "react";
import { TrashIcon } from "@heroicons/react/outline";
import DeletePromptLayerApiKeyModal from "./DeletePromptLayerApiKeyModal";
import moment from "moment";
import { SettingsTable } from "@/components/SettingsTable";
import { Action, Column } from "@/components/SettingsTable/types";

export const PromptLayerApiKeyTable = () => {
  const userContext = useUser();
  const [isDeleteApiKeyModalOpen, setDeleteApiKeyModalOpen] =
    useState<boolean>(false);
  const [selectedApiKeyId, setSelectedApiKeyId] = useState<number | null>(null);

  const apiKeys = userContext.promptLayerWorkspaceApiKeys;

  const handleDelete = (id: number) => {
    setDeleteApiKeyModalOpen(true);
    setSelectedApiKeyId(id);
  };

  const columns: Column<(typeof apiKeys)[0]>[] = [
    {
      header: "API Key",
      content: () => "********",
    },
    {
      header: "User",
      content: (item) => item.email,
    },
    {
      header: "Created At",
      content: (item) => (
        <span title={moment(item.created_at).format("MMMM D, YYYY, HH:mm:ss")}>
          {moment(item.created_at).format("MMMM D, YYYY")}
        </span>
      ),
    },
    {
      header: "Last Active",
      content: (item) => (
        <span title={moment(item.last_active).format("MMMM D, YYYY, HH:mm:ss")}>
          {moment(item.last_active).format("MMMM D, YYYY")}
        </span>
      ),
    },
  ];

  const actions: Action<(typeof apiKeys)[0]>[] = [
    {
      label: "Delete",
      icon: <TrashIcon className="h-4 w-auto pr-1" aria-hidden="true" />,
      onClick: (item) => handleDelete(item.id),
      className: "text-red-500 hover:!bg-red-50 hover:!text-red-600",
    },
  ];

  return (
    <>
      <SettingsTable
        data={apiKeys.sort(
          (a, b) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
        )}
        columns={columns}
        actions={actions}
        keyExtractor={(item) => item.id}
        emptyStateMessage="No PromptLayer API keys found."
      />
      {isDeleteApiKeyModalOpen && selectedApiKeyId && (
        <DeletePromptLayerApiKeyModal
          open={isDeleteApiKeyModalOpen}
          promptLayerApiKeyId={selectedApiKeyId}
          setOpen={setDeleteApiKeyModalOpen}
        />
      )}
    </>
  );
};

export const reformatDate = (datetime: string) => {
  const formattedDate = moment(
    datetime,
    "ddd, DD MMM YYYY HH:mm:ss [GMT]",
  ).format("MMMM D, YYYY");
  return formattedDate;
};
